import useLoginProvider from '@/contexts/LoginContext';
import Select from '@/core/components/Select';
import {
  getFullName,
} from '@/utils/string';
import Button from '@/components/Button';
import {
  PatientOrgMappingDTO,
} from '@/dtos';
import {
  useGetToken,
} from '@/hooks/useApi';
import {
  handleTokenResponse,
  removeSignalRToken,
} from '@/utils/auth';
import isNil from 'lodash/isNil';

export default function OrganizationSelect() {
  const {
    organizations,
    selectedOrg,
    setSelectedOrg,
    handleOrgSelection,
    loginRequestIdHash,
    setPageState,
    isOrgSelectionLoading,
  } = useLoginProvider();
  const { mutateAsync: getToken, isPending: isGetToken } = useGetToken();

  return (
    <div className="flex flex-col gap-4 populate-form login-form">
      <div className="flex flex-col gap-6">
        <Select
          required
          value={selectedOrg}
          options={organizations ?? []}
          getValue={(org) => org?.patientHash ?? ''}
          getLabel={(org) => `${getFullName(org)} - (${org?.organizationName})`}
          onChange={(org) => {
            // Ensure single selection by always taking the first item if it's an array
            if (Array.isArray(org)) {
              setSelectedOrg(org[0] ?? null);
            } else {
              setSelectedOrg(org);
            }
          }}
          placeholder="Select an account"
          label="Organization"
          className="w-full"
          selectClassName="w-full"
          multiple={false}
          muiClasses={{
            root: {
              '& .MuiOutlinedInput-root': {
                height: '48px',
                backgroundColor: 'white',
                '& fieldset': {
                  borderColor: '#E0E0E0',
                  borderWidth: '1px',
                },
                '&:hover fieldset': {
                  borderColor: '#4A4A4A',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#4A4A4A',
                  borderWidth: '1px',
                },
              },
              '& .MuiSelect-icon': {
                color: '#4A4A4A',
              },
            },
          }}
        />
        <div>
          <Button
            variant="login"
            size="login"
            disabled={!selectedOrg || isOrgSelectionLoading || isGetToken}
            onClick={async () => {
              if (!isNil(selectedOrg)){
                const { organizationHash, patientHash } = selectedOrg as PatientOrgMappingDTO;
                const response = await getToken({
                  loginRequestIdHash: loginRequestIdHash ?? null,
                  organizationIdHash: organizationHash ?? '',
                  patientIdHash: patientHash ?? '',
                });

                // Store token, refreshToken, and sessionHash
                handleTokenResponse(response);

                removeSignalRToken();

                await handleOrgSelection(selectedOrg as PatientOrgMappingDTO, response);}
            }}
            className="w-full !h-10 disabled:opacity-50 bg-primary hover:bg-primary/80 text-white font-medium py-2 rounded-lg text-sm md:text-base"
          >
            {isOrgSelectionLoading || isGetToken ? 'Continuing...' : 'Continue'}
          </Button>
          <Button
            variant="link"
            size="login"
            onClick={() => {
              setPageState('login');
            }}
            className="w-full text-primary text-sm p-0 h-auto font-medium"
          >
            Back to Phone Number
          </Button>
        </div>
      </div>
    </div>
  );
}
